import { render, staticRenderFns } from "./SubtasksItem.vue?vue&type=template&id=5726e6ac&"
import script from "./SubtasksItem.vue?vue&type=script&lang=js&"
export * from "./SubtasksItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports